<sirius-grid>
    <div class="sir-container">
        @if (title) {
            <sirius-heading [text]="title" textStyleCategory="title" [size]="headingSize"></sirius-heading>
        }
        <sirius-text-html [html]="textHtml"></sirius-text-html>
    </div>
</sirius-grid>
